<div mat-dialog-title>
    <h2>
        {{ 'browser-test.screen-size-error.title' | translate }}
    </h2>
    <button (click)="close()"
            data-e2e="mobile-redirection-modal-close"
            aria-label="Close dialog"
            class="close">
        <mat-icon svgIcon="cross"></mat-icon>
    </button>
</div>
<mat-card>
    <mat-card-content>
        <p>{{ 'browser-test.screen-size-error.message' | translate:param }}</p>
    </mat-card-content>
    <mat-card-footer>
        <div mat-dialog-actions>
            <button mat-raised-button class="btn-click-here" data-e2e="mobile-redirection-modal-confirm-close" (click)="close()">
                <span>{{'generic.ok' | translate}}</span>
            </button>
        </div>
    </mat-card-footer>
</mat-card>
